import axios from '@/libs/axios'
import { handleCatch } from '@/utils'

export default {
  async getOrganizationProperties() {
    try {
      const response = await axios.get('uni/organizationProperties/getAllProperties')
      const { data } = response
      return data.data
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
}
